import { zodResolver } from '@hookform/resolvers/zod'
import CustomButton from 'components/atoms/CustomButton'
import PhoneNumberFields from 'components/molecules/PhoneNumberFields'
import TextFields from 'components/molecules/TextFields'
import ModalAdmin from 'components/molecules/admin/ModalAdmin'
import { phoneNumberObject } from 'lib/schema'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { checkPhoneNumber } from 'utils/checkPhoneNumber'
import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { validateFields } from 'api'
import { ROLE_ADMIN, ROLE_USER, VALIDATE_FIELDS } from 'constant'
import { showErrorMessage } from 'utils/showMessage'
import { useAuth } from 'hooks'
import SelectFields from '../../../molecules/SelectFields'

const schema = z.object({
  name: z.string().min(1, { message: 'name is requried' }),
  surname: z.string().min(1, { message: 'surname is required' }),
  email: z.string().email({ message: 'Invalid email address' }),
  role: z.string().min(1, { message: 'Role is required' }),
  phoneNumber: phoneNumberObject.or(z.string()).optional()
})
const EditProfileUserModal = ({ show, onClose, onEditProfile, userDetail, isLoading }) => {
  const { t } = useTranslation();
  const { getAccessToken } = useAuth()
  const [loading, setLoading] = useState(false)

  const {
    handleSubmit,
    reset,
    formState: { errors, isDirty, isValid },
    control
  } = useForm({
    defaultValues: {
      name: userDetail?.name || undefined,
      surname: userDetail?.surname || undefined,
      email: userDetail?.email || undefined,
      phoneNumber: userDetail?.phone || '',
      role: userDetail?.role?.role?.toUpperCase() || ''
    },
    resolver: zodResolver(schema)
  })
  async function processForm(data) {
    const newData = checkPhoneNumber(data)

    if(newData?.email !== userDetail?.email){
      try {
        const res = await validateFields(getAccessToken(), { field_name: VALIDATE_FIELDS.email, value: newData.email })
        if (res?.resData?.data) {
          setLoading(false)

        }
      } catch (error) {
        setLoading(false)
        if (error?.response?.data?.errors[0]?.code === 1006) {
          showErrorMessage(t('error messages.Email already exists'))
        } else {

          showErrorMessage(t('error messages.Internal server error'))
        }
        return;
      }
    }


    if(newData?.phoneNumber !== userDetail?.phone){
      try {
        const res = await validateFields(getAccessToken(), { field_name: VALIDATE_FIELDS.phone, value: newData.phoneNumber })
        if (res?.resData?.data) {
          setLoading(false)

        }
      } catch (error) {
        setLoading(false)
        if (error?.response?.data?.errors[0]?.code === 1006) {
          showErrorMessage(t('error messages.CompanyPhone already exists!'))
        } else {
          showErrorMessage(t('error messages.Internal server error'))
        }
        return;
      }
    }


    onEditProfile(newData)
  }
  function closeModal() {
    reset()
    onClose()
  }
  return (
    <ModalAdmin
      width={448}
      show={show}
      onClose={isLoading ? () => { } : closeModal}
      title={t('Edit Profile')}>
      <div className="flex flex-col justify-between">
        <div className="flex flex-col gap-6 w-full">

          <SelectFields
            labelClassName={'!text-white'}
            control={control}
            placeholder={t('Choose Role')}
            label={t('ROLE')}
            errors={errors}
            name={'role'}
            options={[
              {
                label: 'Admin',
                value: ROLE_ADMIN
              },
              {
                label: 'User',
                value: ROLE_USER
              }
            ]}
          />


          <TextFields
            control={control}
            theme="admin"
            label={t('Name')}
            errors={errors}
            name={'name'}
          />
          <TextFields
            control={control}
            theme="admin"
            label={t('Surname')}
            errors={errors}
            name={'surname'}
          />
          <TextFields
            control={control}
            theme="admin"
            label={'Email'}
            errors={errors}
            name={'email'}
          />
          <PhoneNumberFields
            control={control}
            theme="admin"
            label={`${t('Telephone Number')} (${t('optional')})`}
            placeholder={'input phone number'}
            errors={errors}
            name={'phoneNumber'}
          />



          <div className="flex gap-2 justify-end items-center">
            <CustomButton buttonColor="secondary" disabled={isLoading} onClick={onClose}>
              {t('Cancel')}
            </CustomButton>
            <CustomButton
              isLoading={isLoading || loading}
              disabled={!isDirty || !isValid || isLoading || loading}
              onClick={handleSubmit(processForm)}>
              {t('Save Changes')}
            </CustomButton>
          </div>
        </div>
      </div>
    </ModalAdmin>
  )
}

export default EditProfileUserModal
